import { Injectable } from '@angular/core';
import { TaskDetailsObject } from 'src/app/models/tasks/tasks-details/task-details.model';
import { WritableStream } from 'web-streams-polyfill/ponyfill';
import streamSaver from 'streamsaver';
import { AppService } from 'src/app/app.service';
import { NotificationLevel, NotificationsService } from '../api/notifications/notifications.service';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {

  basePath : string;

  constructor(private appService: AppService, private notificationsService: NotificationsService) {
			this.basePath = this.appService.settings.basePath.replace('#','');

   }

  isAssignToUser(task: TaskDetailsObject, userId: string) {
    let assignedTo = task.getProperties().getTaskProperties().getAssignedTo();
    return assignedTo === userId;
  }

  stringMapper(ori: string, params: { [p: string]: string } | undefined): string {
		if (params) {
			let processed = ori;
			for (const key in params) {
				processed = processed.replace(new RegExp('{' + key + '}', 'g'), params[key]);
			}
			processed = encodeURI(processed);
			return processed;
		}
		return ori;
	}

  downloadFileV2(fileDownloadPromise: Promise<Response>, finallyFunc?: () => void): void {
		fileDownloadPromise
			.then(async (response) => {
				if (response.ok && response.body) {
					streamSaver.mitm = window.location.origin + this.basePath +'assets/mitm.html';
					const headerContentDisposition = response.headers.get('content-disposition');
					let filename = 'filename_' + new Date(Date.now()).toISOString() + '.csv';
					if (headerContentDisposition) {
						filename = headerContentDisposition.substring(headerContentDisposition.lastIndexOf('=') + 1);
					}

					if (!window.WritableStream) {
						streamSaver.WritableStream = WritableStream;
						window.WritableStream = WritableStream;
					}

					const fileStream = streamSaver.createWriteStream(filename);
					const readableStream = response.body;

					if (readableStream.pipeTo) {
            if(finallyFunc) { finallyFunc();}
						this.notificationsService.showNotification(
              'El fichero se ha generado correctamente', NotificationLevel.SUCCESS
            );
						return readableStream.pipeTo(fileStream);
					}

					const writer = fileStream.getWriter();

					const reader = response.body.getReader();
					const pump: () => Promise<void> = () =>
						reader.read().then((res) => {
							res.done ? void writer.close() : void writer.write(res.value).then(pump);
						});

					void pump();
          if(finallyFunc) { finallyFunc();}
					this.notificationsService.showNotification(
            'El fichero se ha generado correctamente', NotificationLevel.SUCCESS
          );
					return;
				} else {
          if(finallyFunc) { finallyFunc();}
          this.notificationsService.showNotification(
            'Ha ocurrido un error al descargar el fichero', NotificationLevel.ERROR
          );
					return;
				}
			})
			.catch(() => {
        if(finallyFunc) { finallyFunc();}
				this.notificationsService.showNotification(
          'Ha ocurrido un error al descargar el fichero', NotificationLevel.ERROR
        );
			});
	}

}
